import {useMe} from '@features/user/queries/useMe.ts'
import {countryNameFromCode} from '@features/floor-plan/country-names.ts'

export interface FloorPlanOptInDefaults {
    airbnbUserId: string
    email: string
    firstName: string
    lastName: string
    city: string
    country: string
}

/**
 * Prefill values for the opt-in form, sourced from the current photographer.
 * userId/email/name come from the real `useMe`; city is a free-text field that
 * starts empty, while country is prefilled from the photographer's address
 * country code mapped to its English name (e.g. "FR" → "France"), still editable.
 * Returns `undefined` until the user is loaded.
 */
export const useFloorPlanOptInDefaults = (): FloorPlanOptInDefaults | undefined => {
    const {data: user} = useMe()

    if (!user) {
        return undefined
    }

    return {
        airbnbUserId: user.airbnbUserId ? String(user.airbnbUserId) : '',
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName ?? '',
        city: '',
        country: countryNameFromCode(user.country)
    }
}
